module.exports = __webpack_public_path__ + "img/dwerve_follow.f8a40dbc.jpeg";